export default __webpack_public_path__ + "static/media/charge.9cd809ba.png";